import axios from 'axios'

export default axios.create({
  baseURL: "https://api.ch-9.net/api/v1",
  headers: {
    "Content-type": "application/json"
  }
});
